import ClinicalMedication from './components/clinical-medication-container';

export default ClinicalMedication;
